import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WowInit from "../../components/wowInit/wowInit";

// ✅ Home Pages
import Homepage from "../HomePage";
import HomePage2 from "../HomePage2/HomePage2";
import HomePage3 from "../HomePage3/HomePage3";
import HomePage4 from "../HomePage4/HomePage4";
import HomePage5 from "../HomePage5/HomePage5";
import HomePage6 from "../HomePage6/HomePage6";
import InvitationPage1 from "../InvitationPage1/InvitationPage1";

import AboutPage from "../AboutPage/AboutPage";
import StoryPage1 from "../StoryPage1/StoryPage1";
import StoryPage2 from "../StoryPage2/StoryPage2";
import StoryPage3 from "../StoryPage3/StoryPage3";
import AccomodationPage from "../AccomodationPage/AccomodationPage";
import RsvpPage1 from "../RsvpPage1/RsvpPage1";
import RsvpPage2 from "../RsvpPage2/RsvpPage2";
import RsvpPage3 from "../RsvpPage3/RsvpPage3";
import GalleryPage from "../GalleryPage/GalleryPage";
import PlannerPage from "../PlannerPage/PlannerPage";
import TeamSinglePage from "../TeamSinglePage/TeamSinglePage";
import BrideGroomsPage from "../BrideGroomsPage/BrideGroomsPage";
import ServicePage from "../ServicePage/ServicePage";
import ServiceSinglePage from "../SeviceSinglePage";
import PricingPage from "../PricingPage/PricingPage";
import ComingSoonPage from "../ComingSoonPage/ComingSoonPage";

import PortfolioGridPage from "../PortfolioGridPage/PortfolioGridPage";
import PortfolioGridPageS2 from "../PortfolioGridPageS2/PortfolioGridPageS2";
import PortfolioGridPageS3 from "../PortfolioGridPageS3/PortfolioGridPageS3";
import PortfolioMasonaryPage from "../PortfolioMasonaryPage/PortfolioMasonaryPage";
import ProjectSinglePage from "../ProjectSinglePage";

import ShopPage from "../ShopPage";
import ProductSinglePage from "../ProductSinglePage";
import CartPage from "../CartPage/CartPage";
import WishlistPage from "../WishlistPage/WishlistPage";
import CheckoutPage from "../CheckoutPage";
import OrderRecived from "../OrderRecived/OrderRecived";

import BlogPage from "../BlogPage/BlogPage";
import BlogPageLeft from "../BlogPageLeft/BlogPageLeft";
import BlogPageFullwidth from "../BlogPageFullwidth/BlogPageFullwidth";
import BlogDetails from "../BlogDetails/BlogDetails";
import BlogDetailsFull from "../BlogDetailsFull/BlogDetailsFull";
import BlogDetailsLeftSiide from "../BlogDetailsLeftSiide/BlogDetailsLeftSiide";

import ContactPage from "../ContactPage/ContactPage";
import LoginPage from "../LoginPage";
import SignUpPage from "../SignUpPage";
import ForgotPassword from "../ForgotPassword";
import ErrorPage from "../ErrorPage/ErrorPage";

// ✅ Router Component
const AllRoute: React.FC = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <WowInit />

        <Routes>
          {/* ✅ Home Routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/home-2" element={<HomePage2 />} />
          <Route path="/home-3" element={<HomePage3 />} />
          <Route path="/home-4" element={<HomePage4 />} />
          <Route path="/home-5" element={<HomePage5 />} />
          <Route path="/home-6" element={<HomePage6 />} />
          <Route path="/invitation" element={<InvitationPage1 />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/story" element={<StoryPage1 />} />
          <Route path="/story-2" element={<StoryPage2 />} />
          <Route path="/story-3" element={<StoryPage3 />} />
          <Route path="/accomodation" element={<AccomodationPage />} />
          <Route path="/rsvp" element={<RsvpPage1 />} />
          <Route path="/rsvp-2" element={<RsvpPage2 />} />
          <Route path="/rsvp-3" element={<RsvpPage3 />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/planner" element={<PlannerPage />} />
          <Route path="/team-single/:slug" element={<TeamSinglePage />} />
          <Route path="/groom-bride" element={<BrideGroomsPage />} />
          <Route path="/service" element={<ServicePage />} />
          <Route path="/service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/coming" element={<ComingSoonPage />} />

          {/* ✅ Portfolio */}
          <Route path="/portfolio-grid" element={<PortfolioGridPage />} />
          <Route path="/portfolio-grid-s2" element={<PortfolioGridPageS2 />} />
          <Route path="/portfolio-slide" element={<PortfolioGridPageS3 />} />
          <Route path="/portfolio-masonary" element={<PortfolioMasonaryPage />} />
          <Route path="/project-single/:slug" element={<ProjectSinglePage />} />

          {/* ✅ Shop */}
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/product-single/:slug" element={<ProductSinglePage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/wishlist" element={<WishlistPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/order_received" element={<OrderRecived />} />

          {/* ✅ Blog */}
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog-single/:slug" element={<BlogDetails />} /> 
          <Route path="/blog-left-sidebar" element={<BlogPageLeft />} />
          <Route path="/blog-fullwidth" element={<BlogPageFullwidth />} />
          <Route path="/blog-single-left-sidebar/:slug" element={<BlogDetailsLeftSiide />} />
          <Route path="/blog-single-fullwidth/:slug" element={<BlogDetailsFull />} />

          {/* ✅ Contact & Auth */}
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<SignUpPage />} />
          <Route path="/forgot" element={<ForgotPassword />} />

          {/* ✅ Error Page */}
          <Route path="/404" element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
